import PropTypes from 'prop-types';
import React from 'react';
import track from '@helper/tracking';
import Headline from '../../atoms/headline/headline';
import MixedCopy from '../mixed-copy/mixedCopy';
import StyledBasicTeaserShaped from './basicTeaserShaped.style';
import ArrowLink from '../arrow-link/arrowLink';
import { buildSrcSet } from '../../../helper/index';

const BasicTeaserShaped = props => {
  const { introCopy, headline, titleImage, teaserImage, guidedTourTeaserImage, subline, uri } =
    props;

  let usedImage = {};
  // Check if teaserImage is an array
  let teaserImageTmp = teaserImage;
  if (Array.isArray(teaserImageTmp)) {
    [teaserImageTmp] = teaserImageTmp; // Use the first element if it's an array
  }
  // Check if titleImage is an array
  let titleImageTmp = titleImage;
  if (Array.isArray(titleImageTmp)) {
    [titleImageTmp] = titleImage; // Use the first element if it's an array
  }

  if (teaserImageTmp && (teaserImageTmp?.src || teaserImageTmp?.url)) {
    usedImage = teaserImageTmp;
  } else if (titleImageTmp && (titleImageTmp?.src || titleImageTmp?.url)) {
    usedImage = titleImageTmp;
  }

  let usedImageSrscet = usedImage.srcset;
  if (Array.isArray(usedImageSrscet)) {
    usedImageSrscet = buildSrcSet(usedImageSrscet);
  }

  // event dates have a different structure
  if (guidedTourTeaserImage) {
    usedImage = guidedTourTeaserImage;
  }

  return (
    <StyledBasicTeaserShaped {...props}>
      <div className="teaser__container">
        <div className="teaser__image">
          <img
            loading="lazy"
            alt={usedImage.alt ?? headline}
            src={usedImage?.url ?? usedImage?.src}
            srcSet={usedImageSrscet ?? ''}
            sizes="(min-width: 768px) 33vw, 100vw"
          />
        </div>

        <div className={`teaser__content-container ${usedImage.url ? 'with-mask' : ''}`}>
          <div className="teaser__content-inner">
            <div className="teaser__mask" aria-hidden="true" />
            <div className="teaser__content">
              <div className="teaser__headlines">
                {subline && <Headline tag="span">{subline}</Headline>}
                <Headline tag="h3" tertiary>
                  {headline}
                </Headline>
              </div>
              {introCopy && (
                <MixedCopy
                  fullWidth
                  html={introCopy.length > 200 ? `${introCopy.substring(0, 200)}...` : introCopy}
                />
              )}
            </div>
          </div>
          {uri && (
            <div className="teaser__link">
              <ArrowLink
                onClick={() => {
                  track(['trackEvent', 'BasicTeaser', 'Click', headline]);
                }}
                href={uri}
                stretched
              />
            </div>
          )}
        </div>
      </div>
    </StyledBasicTeaserShaped>
  );
};

BasicTeaserShaped.propTypes = {
  titleImage: PropTypes.arrayOf(PropTypes.shape()),
  teaserImage: PropTypes.arrayOf(PropTypes.shape()),
  guidedTourTeaserImage: PropTypes.arrayOf(PropTypes.shape()),
  headline: PropTypes.string.isRequired,
  subline: PropTypes.string,
  introCopy: PropTypes.string,
  uri: PropTypes.string
};

export default BasicTeaserShaped;
